/* eslint-disable complexity */
import { Injectable } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  CreateMyPasswordFormAttributes,
  CreateMyPasswordMessages,
  CreateMyPasswordPageContent,
  ErrorMessage,
  Errors
} from '@com-delta-idp/mnx-login-ui';
import {
  forbiddenCharacters,
  hasNumberAndLetter,
  hasUpperAndLowerCase,
  lengthValidation,
  moreThan3SpecialCharacters,
  password_equalto_check
} from '../../../validator';
import { createNewPasswordRegExList } from '../../../validator/regex-list';
import { LoginModalContent } from '../../models/aem';

@Injectable({
  providedIn: 'root'
})
export class CreateMyPasswordHelperService {
  formGroup!: UntypedFormGroup;

  createForm(): UntypedFormGroup {
    this.formGroup = new UntypedFormGroup({
      newPassword: new UntypedFormControl(null, [
        Validators.required,
        forbiddenCharacters(),
        moreThan3SpecialCharacters(),
        hasNumberAndLetter(),
        hasUpperAndLowerCase(),
        lengthValidation()
      ]),
      confirmPassword: new UntypedFormControl(null, [
        Validators.required,
        password_equalto_check
      ])
    });
    return this.formGroup;
  }

  mustContainStatus(password: string): string[] {
    return this.passwordHintStatus(
      createNewPasswordRegExList.mustContain,
      password,
      true
    );
  }

  cannotContainStatus(password: string, username: string): string[] {
    if (username !== undefined && username !== '') {
      const userId_regex = new RegExp(`^${username}$`);
      createNewPasswordRegExList.cannotContain[2] = new RegExp(
        createNewPasswordRegExList.cannotContain[2].source +
          '|' +
          userId_regex.source,
        'i'
      );
    }
    return this.passwordHintStatus(
      <RegExp[]>createNewPasswordRegExList.cannotContain,
      password,
      false
    );
  }

  passwordHintStatus(
    regexList: RegExp[],
    password: string,
    flag?: boolean
  ): string[] {
    const statusList: string[] = [];
    for (const index in regexList) {
      if (password.length === 0) {
        statusList[index] = '';
      } else {
        if (
          flag
            ? password.match(regexList[index])
            : !password.match(regexList[index])
        ) {
          statusList[index] = 'success';
        } else {
          statusList[index] = 'error';
        }
      }
    }
    return statusList;
  }

  getCreateMyPasswordPageContent(
    aemResponse: LoginModalContent
  ): CreateMyPasswordPageContent {
    const { setPassword, pageHeader } = aemResponse;
    return {
      ...setPassword,
      pageHeader: {
        ...pageHeader,
        headerTitle: setPassword.headerTitle,
        headerSubTitle: setPassword.headerSubTitle
      },
      messages: this.getInitialErrorMessage(aemResponse.errors),
      showPassword: false
    };
  }

  getInitialErrorMessage(errors: Errors): CreateMyPasswordMessages {
    let newPasswordErrorMessages = '',
      confirmPasswordErrorMessages = '',
      alertWarningErrorMessages = '';
    errors.errorMessages.forEach((option: ErrorMessage) => {
      if (option['errorId'] === 'newPassword') {
        newPasswordErrorMessages = option['errorMessageDescription'];
      }
      if (option['errorId'] === 'confirmPassword') {
        confirmPasswordErrorMessages = option['errorMessageDescription'];
      }
      alertWarningErrorMessages = 'To continue, please correct the';
    });
    return {
      newPasswordErrorMessage: newPasswordErrorMessages,
      confirmPasswordErrorMessage: confirmPasswordErrorMessages,
      alertWarning: alertWarningErrorMessages,
      cannotContainValidationList: [],
      mustContainValidationList: []
    };
  }

  getFormAttributes(): CreateMyPasswordFormAttributes {
    return {
      errorCount: 0,
      submitAttempt: false,
      errorAlertBanner: false,
      newPasswordControlTouched: false,
      confirmPasswordControlTouched: false,
      disableActionButton: false
    };
  }
}
